import { Capacitor } from '@capacitor/core';
import { nativeBilling } from './nativeBilling';
import { paymentsAPI } from './api';

const isNativeAndroid = () =>
  Capacitor?.isNativePlatform?.() === true && Capacitor.getPlatform() === 'android';

const redirectToUrl = (url) => {
  if (!url) {
    throw new Error('The billing service did not return a checkout URL.');
  }

  window.location.assign(url);
};

const createBrowserTopupCheckout = async (packId, { successUrl, cancelUrl } = {}) => {
  const response = await paymentsAPI.createStripeCheckout({
    mode: 'payment',
    priceKey: packId,
    successUrl,
    cancelUrl,
  });

  redirectToUrl(response?.data?.data?.url);

  return {
    channel: 'stripe',
    redirected: true,
  };
};

const createBrowserBillingPortal = async (returnUrl) => {
  const response = await paymentsAPI.createStripePortal({
    returnUrl,
  });

  redirectToUrl(response?.data?.data?.url);

  return {
    channel: 'stripe',
    redirected: true,
  };
};

export const purchaseService = {
  isNativeAndroidPurchase({ userId } = {}) {
    return isNativeAndroid() && Boolean(userId);
  },

  async purchaseTokens({ packId, userId, successUrl, cancelUrl }) {
    if (this.isNativeAndroidPurchase({ userId })) {
      return nativeBilling.purchaseTokenPack({
        packId,
        appUserID: userId,
      });
    }

    return createBrowserTopupCheckout(packId, { successUrl, cancelUrl });
  },

  async openManageBilling({ userId, returnUrl } = {}) {
    return createBrowserBillingPortal(returnUrl || window.location.href);
  },
};
